import { fetchTranslations } from "../api/TranslationAPI"

export const TranslationReducer = (state, action) => {
    switch (action.type) {
        case "LOAD_DATA":
            const  {stringSets, dispatcher} = action.data;
            fetchTranslations({stringSets}, dispatcher);
            return state
        case "SET_DATA":
            return { ...state, ...action.data }  
        case "UNLOAD_DATA":
            return state; 
        default:
            return state

    }
}


// WEBPACK FOOTER //
// ./src/commons/reducer/TranslationReducer.js